import { RowMenu } from '@components/RowMenu';
import { RowMenuItem } from '@components/RowMenuItem';
import { IMenu } from '@hooks/useMenu';
import useMessage from '@hooks/useMessage';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { IRetorno } from '@model/Retorno';
import { useRetornoService } from '@services/RetornoService';
import React from 'react';

export type RetornoMenuProps = {
    menu: IMenu
    retorno: IRetorno
}

export function RetornoMenu ({ menu, retorno }: RetornoMenuProps) {
    const retornoService = useRetornoService();
    const message = useMessage();

    const handleBaixarArquivo = React.useCallback(() => {
        retornoService.baixarArquivo(retorno.retornoId)
            .catch(message.showBlobException);
    }, [message.showBlobException, retorno.retornoId, retornoService]);

    return (
        <RowMenu menu={menu}>
            <RowMenuItem 
                key={0} 
                onClick={menu.handleItemClick(handleBaixarArquivo)}
                text="Baixar Arquivo"
                icon={<CloudDownloadIcon />}
            />
        </RowMenu>
    )
}